export class ErrorViewModel{
    public status: number = 0;
    public type?: string;
    public message?: string;
    public errorTime?: string;
}